import { useAuthQuery } from "@stadium/services/apollo-client";
import { FETCH_SWAG_FLOW_USER_CONFIG } from "@graphql/queries/user/fetch-swag-flow-user-config";

const useFetchSwagFlowUserConfig = ({ skip = false } = {}) => {
  const { data, loading, refetch } = useAuthQuery(FETCH_SWAG_FLOW_USER_CONFIG, {
    fetchPolicy: "cache-and-network",
    skip,
  });

  return { data: data?.user, loading, refetch };
};

export default useFetchSwagFlowUserConfig;
